import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import Logger = require("js-logger");

export default class IsBonusRecoveryTriggered extends Decision {

    private bonusId: string;

    constructor(bonus: string) {
        super();

        this.bonusId = bonus;
    }

    public evaluate() {
        const record = GameState.getCurrentGame().getFirstRecord();

        let triggered = false;
        if (record) {
            if (record.isBonusTriggered(this.bonusId)) {
                triggered = true;
            }
        }

        return triggered ? Exit.True : Exit.False;
    }
}
